import CryptoJS from "crypto-js";

const CRYPTO_KEY = "RZM15kr$Oh=IxG#o";

export function theEncrypt(text) {
  const payload = typeof text !== "string" ? JSON.stringify(text) : text;
  const key = CryptoJS.enc.Utf8.parse(CRYPTO_KEY);
  const srcs = CryptoJS.enc.Utf8.parse(payload);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

export function theDecrypt(text) {
  const payload = typeof text !== "string" ? JSON.stringify(text) : text;
  const key = CryptoJS.enc.Utf8.parse(CRYPTO_KEY);
  const decrypt = CryptoJS.AES.decrypt(payload, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

export function urlSafeBase64Encrypt(text) {
  const base64 = theEncrypt(text);
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
